import React from 'react';
import { connect } from 'react-redux';
import { updateCapacity, getAllCapacities } from '../Dashboard/DashboardActions';
import Capacity from '../../views/Capacity';
import { toast } from 'react-toastify';
import {Map} from 'immutable';
import moment from 'moment';

class CapacityContainer extends React.Component {

  constructor(props) {
    super(props);
    this.update = this.update.bind(this);
    this.onSliderChange = this.onSliderChange.bind(this);
    this.onDateChange = this.onDateChange.bind(this);

    let date = moment();
    let start = date.startOf('day');
    let end = date.endOf('day');

    this.state = {
      updated: new Map(),
      date: date,
      start: start.format('YYYY-MM-DD'),
      end: end.format('YYYY-MM-DD')
    };
  }


  update() {
    let terminalObj = this.state.updated.toObject();
    let { dipatchUpdateCapacity, disptachGetAllCapacities } = this.props;
    let { start, end } = this.state;
    let terminals = Object.entries(terminalObj).map(entry => {
      return {
        name: entry[0],
        value: entry[1],
        start,
        end
      };
    });

    dipatchUpdateCapacity(terminals, (err, data) => {
      if (!err) {
        let paramaters = {
          start,
          end
        };
        toast.success("Capacity Updated");
        disptachGetAllCapacities(paramaters);
      }else{
        toast.error(err.message);
      }
    });
  }

  onSliderChange(name, e) {
    let state = {};
    state[name] = e;
    this.setState((prevState) => {
      //let newChange = prevState.updated;
      //newChange = newChange.merge(state);
      prevState.updated = prevState.updated.merge(state);
      return prevState;
    });
  }

  onDateChange(date) {
    this.setState({ date: moment(date) }, () => {

      const {disptachGetAllCapacities} = this.props;
      let startString = moment(date) .format('YYYY-MM-DD');
      let endString = moment(date) .format('YYYY-MM-DD');

      let paramaters = {
        start: startString,
        end: endString
      };

      disptachGetAllCapacities(paramaters, (err, data) => {
        if (!err) {
          this.setState({            
            start: startString,
            end: endString
          });
        }
      });
    });
  }

  componentDidMount() {
    const { disptachGetAllCapacities } = this.props;
    const { start, end, date } = this.state;
    let paramaters = {
      start,
      end
    };
    disptachGetAllCapacities(paramaters);
  }

  render() {
    const { capacity } = this.props;
    const { date } = this.state;
    return <Capacity
      onSliderChange={this.onSliderChange}
      date={date}
      capacity={capacity}
      submit={this.update}
      onDateChange={this.onDateChange} />;
  }
}



const mapStateToProps = (state) => ({
  //terminals: state.business.terminals.get('data') || [],
  capacity: state.business.capacity
});


const mapDisptatchToProps = (dispatch) => ({
  // dispatchGetTerminals: (callback) => { dispatch(getTerminals(callback));},
  disptachGetAllCapacities: (paramaters, cb) => dispatch(getAllCapacities(paramaters, cb)),
  dipatchUpdateCapacity: (parameters, callback) => { dispatch(updateCapacity(parameters, callback)); }
});



export default connect(mapStateToProps, mapDisptatchToProps)(CapacityContainer);


// WEBPACK FOOTER //
// ./src/containers/Capacity/CapacityContainer.js